<template>
  <div v-if="!progress">
    <v-card-text>
      <v-container>
        <v-row
          align="start"
          pb-3>
          <v-col cols="12">
            <span>生徒</span>
            <v-list-item-content class="title">
              <span class="text--primary">
                {{ this.student.grade().toJapanese() }}
                {{ this.student.genderInJapanese() }}
              </span>
            </v-list-item-content>
          </v-col>
          <v-col cols="12">
            <span>最寄駅</span>
            <v-list-item-content class="title">
              <span class="text--primary">
                {{ this.student.nearestStation }}
              </span>
            </v-list-item-content>
          </v-col>
          <v-col cols="12">
            <span>希望日時</span><br>
            <v-chip
              v-for="schedule in this.student.availableSchedulesToStrings()"
              :key="schedule"
              outlined
              class="ma-1"
            >
              {{ schedule }}
            </v-chip>
          </v-col>
        </v-row>
        <v-row
          v-if="request.isAccepted()"
          justify="center">
          <v-col cols="12">
            <v-list-item class="title">
              <span>このリクエストは承認済みです。</span>
            </v-list-item>
          </v-col>
          <v-btn
            depressed
            rounded
            outlined
            class="ml-5"
            @click="confirm">
            確認
          </v-btn>
        </v-row>
        <v-row
          v-else-if="request.isInRequest()"
          justify="center">
          <v-col cols="12">
            <v-list-item class="title">
              <span>このリクエストは未承認(承認待ち)です。</span>
            </v-list-item>
          </v-col>
          <v-btn
            rounded
            outlined
            class="ml-5"
            @click="confirm">
            取り消す
          </v-btn>
        </v-row>
        <v-row
          v-else
          justify="center">
          <v-col cols="12">
            <v-list-item class="title">
              <span>このリクエストは見送られました。</span>
            </v-list-item>
          </v-col>
          <v-btn
            depressed
            rounded
            outlined
            class="ml-5"
            @click="confirm">
            確認
          </v-btn>
        </v-row>
      </v-container>
    </v-card-text>
    <v-divider></v-divider>
  </div>
</template>

<script>
import { firestore } from '@/repository/client/firestore.js'
import { StudentRepository } from '@/repository/StudentRepository.js'

export default {
  name:'RequestsByTeacher',
  data() {
    return {
      student: null,
      progress: true
    }
  },
  props: {
    request: Object,
  },
  methods: {
    confirm(request) {
      this.$emit("confirm", request)
    }
  },
  created: async function(){
    const studentRepo = new StudentRepository(firestore)
    this.student = await studentRepo.get(this.request.studentId)
    this.progress = false
  }
}
</script>